export default __webpack_public_path__ + "static/media/l2.7563d473.png";